/**
 * string representations of the sizes of image available in the dam.
 * Modify this to contain the sizes of images available if the sizes are changed
 * @type {string[]}
 */
const imageSizes = ['.imgw.48.48.png', '.imgt.140.100.png', '.imgt.319.319.png', '.imgt.540.540.png', '.imgt.720.720.png', '.imgw.1280.1280.png'];
const shortImageSizes = ['.imgt.540.540.png', '.imgt.720.720.png', '.imgw.1280.1280.png'];
/**
 * suggested image sizes for the browser to use during compute
 * @type {string[]}
 */
const imageBreakPoints = ['48w', '140w', '319w', '540w', '720w', '1280w'];

const shortBreakpoints = ['319w', '540w', '720w'];
/**
 * strong suggestion to browser for which image size to load for a given device width
 * @type {string}
 */
const sizesString = '(max-device-width: 480px) 540px, (max-device-width: 700px) 720px, 1000px';

export default {
    createSRCSET: createSRCSET,
    getSizedURL: getSizedURL,
    getSizesString: getSizesString
}

/**
 * create a srcset string for use with image tags. This string will contain all sizes of the image available
 * (including original) as specified in the imageSizes and imageBreakPoints arrays
 * @param originalUrl
 * @returns {string}
 */
function createSRCSET(originalUrl, noThumbnail) {
    let fullString = `${originalUrl},`;
    let allSizes = imageSizes;
    let breakpoints = imageBreakPoints;
    if(fullString.indexOf('/dam/') >= 0){
        let i = 0;
        if (noThumbnail) {
            breakpoints = shortBreakpoints;
            allSizes = shortImageSizes;
        }
        for (i; i < allSizes.length; i++) {
            fullString = `${fullString} ${originalUrl}${allSizes[i]} ${breakpoints[i]},`;
        }
        fullString = fullString.slice(0, -1);
    }
    return fullString;
}

/**
 *
 * @param originalUrl
 * @param size - number representing the size of image to request
 *               values are:
 *               -1 : original image
 *                0 : thumbnail 48x48
 *                1 : thumbnail 140x100
 *                2 : small     319x319
 *                3 : large     1280x1280
 * @returns {string}
 */
function getSizedURL(originalUrl, size) {
    return originalUrl + (size >= 0 ? imageSizes[size] : '');
}

function getSizesString() {
    return sizesString;
}



